export const API_BASE_URL = "https://swaramayi.info";